import React, { useState, useEffect } from 'react';

interface LoadingDotsProps {
  /** 几个点 */
  dotsLength?: number;
  /** 间隔时间 */
  duration?: number;
}

// 默认点的数量
const DEFAULT_LOADINGDOTS_LENGTH = 3;
// 默认间隔时间
const DEFAULT_DURATION = 500;

// ... 三个点一个一个出现并循环
const LoadingDots: React.FC<LoadingDotsProps> = ({
  dotsLength = DEFAULT_LOADINGDOTS_LENGTH,
  duration = DEFAULT_DURATION,
}) => {
  const [dots, setDots] = useState<string>('');

  useEffect(() => {
    // 定义一个定时器，每300ms更新一次点的数量
    const interval = setInterval(() => {
      setDots((prevDots) => {
        // 如果点的数量达到 dotsLength 个，重置为0
        if (prevDots.length >= dotsLength) {
          return '';
        }
        // 否则添加一个点
        return prevDots + '.';
      });
    }, duration);

    // 组件卸载时清除定时器
    return () => clearInterval(interval);
  }, [dotsLength, duration]);

  return <>{dots}</>;
};

export default LoadingDots;
